import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "card"
};
const _hoisted_2 = {
  class: "membership-card"
};
const _hoisted_3 = {
  key: 0,
  class: "error-tip"
};
const _hoisted_4 = {
  key: 1,
  class: "auth-loading"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[2] || (_cache[2] = _createElementVNode("h2", {
    class: "card-title"
  }, "会员尊享", -1)), _cache[3] || (_cache[3] = _createElementVNode("ul", {
    class: "card-benefits"
  }, [_createElementVNode("li", null, [_createElementVNode("i", {
    class: "fas fa-gift"
  }), _createTextVNode(" 每日免费领一杯")])], -1)), _createElementVNode("button", {
    class: "btn-primary",
    onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => $setup.startWechatAuth && $setup.startWechatAuth(...args), ["prevent"]))
  }, [...(_cache[1] || (_cache[1] = [_createElementVNode("span", null, "立即领取会员卡", -1)]))])]), $setup.authStore.error ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_cache[4] || (_cache[4] = _createElementVNode("i", {
    class: "fas fa-exclamation-circle"
  }, null, -1)), _createTextVNode(" " + _toDisplayString($setup.authStore.error), 1)])) : _createCommentVNode("", true), $setup.authStore.showAuthLoading ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[5] || (_cache[5] = [_createElementVNode("div", {
    class: "loading-spinner"
  }, null, -1), _createElementVNode("p", {
    class: "loading-text"
  }, "微信授权中，请稍候...", -1)]))])) : _createCommentVNode("", true)]);
}